import { render } from "./OrderTextarea.vue?vue&type=template&id=9f4b6e3a&scoped=true"
import script from "./OrderTextarea.vue?vue&type=script&lang=js"
export * from "./OrderTextarea.vue?vue&type=script&lang=js"

import "./OrderTextarea.vue?vue&type=style&index=0&id=9f4b6e3a&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4b6e3a"]])

export default __exports__